import React from 'react';
import ReactDOM from 'react-dom';
import { Gmaps, Marker, InfoWindow, Circle } from 'react-gmaps';


const params = { v: '3.exp', key: 'AIzaSyAhkUyLF1d-X4b-4s29nzI6VS1nTAh9Q68' };


export default class maps extends React.Component {
    constructor() {
        super();
        this.state = {
        }

    }
    onMapCreated(map) {
        map.setOptions({
            disableDefaultUI: true
        });
    }

    onDragEnd(e) {
        console.log('onDragEnd', e);
    }

    onCloseClick() {
        console.log('onCloseClick');
    }

    onClick(e) {
        console.log('onClick', e);
    }

    render() {
        return (
            <Gmaps
                width={'768px'}
                height={'600px'}
                lat={this.props.lat}
                lng={this.props.lon}
                zoom={15}
                loadingMessage={'Be happy'}
                params={params}
                onMapCreated={this.onMapCreated}>
                <Marker
                    lat={this.props.lat}
                    lng={this.props.lon}
                    draggable={true}
                    onDragEnd={this.onDragEnd} />
            </Gmaps>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/data/maps.js